<script lang="ts">
	import type { EventCellClicked } from "./event_types";
	import { Game } from './game.ts';
	import { onMount, onDestroy } from 'svelte';

	import Header from './Header.svelte';
	import Field from './Field.svelte';

	let game: Game;

	let startTime: Date;
	let currentTime: Date;
	let timerInterval: number;

	function restart(): void {
		if (game && game.isPlaying) stop();

		game = new Game();

		currentTime = startTime = new Date();
		timerInterval = window.setInterval(() => currentTime = new Date(), 1000);

		console.log('игра перезапущена');
	}

	function stop(): void {
		window.clearInterval(timerInterval);
		console.log('игра остановлена');
	}

	onMount(restart);
	onDestroy(stop);

	function clicked(event: CustomEvent): void {
		let {setMark, cell} = <EventCellClicked>event.detail;

		if (setMark) game.markCell(cell);
		else game.checkCell(cell);

		game.cells = game.cells; // reactive hack

		if ( ! game.isPlaying) {
			stop();
			console.log(game.isWon ? 'пользователь победил' : 'пользователь проиграл');

			if (game.isWon) alert('Поздравляем, вы выиграли!');
		}
	}
</script>

{#if game}
	<Header {startTime} {currentTime} flagsLeft="{game.flagsLeft}" on:restart="{restart}"/>
	<main>
		<Field cells="{game.cells}" on:cell_clicked="{clicked}"/>
	</main>
{:else}
	<p>Запуск...</p>
{/if}

<style>
	:global(html, body) {
		position: relative;
		width: 100%;
		height: 100%;
	}
	:global(body) {
		color: #333;
		margin: 0;
		padding: 8px;
		box-sizing: border-box;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', sans-serif;
		font-size: 24px;
	}
	:global(a) {
		color: rgb(0, 100, 200);
		text-decoration: none;
		cursor: pointer;
	}
	:global(a:hover) {
		text-decoration: underline;
	}

	main {
		display: block;
		clear: both;
	}
</style>
